import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getSendWelcomeEmailsProgress,
    sendWelcomeEmails,
    stopBulkSending,
} from 'src/openapi/admin/apis/BulkSendWelcomeEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {SendWelcomeEmailModal} from './send-welcome-email.modal';
import {
    selectSendWelcomeEmailBulkUuid,
    selectSendWelcomeEmailTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './send-welcome-email.slice';

import type {WelcomeEmailSendRequest} from 'src/openapi/admin/models/WelcomeEmailSendRequest';

type Props = {
    shown: boolean,
    userIds: number[],
    accountId: number,
    onDone: () => void,
    onClose: () => void,
};

const MODAL_WIDTH = 450;

export const SendWelcomeEmailTool = ({shown, userIds, onDone, accountId, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<WelcomeEmailSendRequest>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectSendWelcomeEmailTask}
            uuidSelector={selectSendWelcomeEmailBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={welcomeEmailSendRequest => (
                apiDispatch(sendWelcomeEmails({welcomeEmailSendRequest}))
            )}
            getProgress={id => apiDispatch(getSendWelcomeEmailsProgress({id}))}
            stopAction={id => apiDispatch(stopBulkSending({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <SendWelcomeEmailModal {...{userIds, onCloseModal, processAction, accountId}}/>
            )}
        </BulkActionTool>
    );
};
